import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_SCHOOLS_URL;

export default {
  getSchools() {
    return $axios.get('api/v1/school/minimum', { baseURL: baseUrl });
  },
  getSchoolSelection(active) {
    return $axios.get(`api/v1/school/selection${active ? '/active' : ''}`, {
      baseURL: baseUrl,
    });
  },
  getAllSchools() {
    return $axios.get('api/v1/school/all', { baseURL: baseUrl });
  },
  getPagedSchools(paging) {
    return $axios.post('api/v1/school/paged', paging, { baseURL: baseUrl });
  },
  getSchool(id) {
    return $axios.get(`api/v1/school/details/${id}`, { baseURL: baseUrl });
  },
  getSchoolLicenses(id) {
    return $axios.get(`api/v1/school/${id}/licenses`, { baseURL: baseUrl });
  },
  getSchoolForUser() {
    return $axios.get('api/v1/school/details', { baseURL: baseUrl });
  },
  getLicensesBySchoolId() {
    return $axios.get('api/v1/school/details', { baseURL: baseUrl });
  },
  getUnpaidLicenses() {
    return $axios.get('api/v1/school/unpaid', { baseURL: baseUrl });
  },
  createStripeSession(school) {
    return $axios.post('api/v1/Stripe/CreateStripeSession', school, {
      baseURL: baseUrl,
    });
  },
  createSchool(school) {
    return $axios.post('api/v1/school/import', school, { baseURL: baseUrl });
  },
  addLicense(schoolId, license) {
    return $axios.post(`api/v1/school/${schoolId}/license`, license, {
      baseURL: baseUrl,
    });
  },
  updateLicense(schoolId, license) {
    return $axios.put(
      `api/v1/school/${schoolId}/license/${license.id}`,
      license,
      { baseURL: baseUrl },
    );
  },
  removeLicense(schoolId, licenseId) {
    return $axios.delete(`api/v1/school/${schoolId}/license/${licenseId}`, {
      baseURL: baseUrl,
    });
  },
  payLicense(schoolId, licenseId, amount) {
    return $axios.post(
      `api/v1/school/${schoolId}/license/${licenseId}/pay`,
      amount,
      { baseURL: baseUrl },
    );
  },
  getActiveLicense() {
    return $axios.get('api/v1/school/activelicense', { baseURL: baseUrl });
  },
};



// WEBPACK FOOTER //
// ./src/api/schools.js